import React, { useEffect, useState } from "react";
import * as API from "../../utils/api.service";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { Icon } from 'react-icons-kit';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { eye } from 'react-icons-kit/feather/eye';
import {
  EMAIL_VALIDATION,
  PASSWORD_VALIDATION,
  TEXT_WITH_SPACE_VALIDATION,
  MOBILE_VALIDATION,
  SWIT_SUCCESS,
  TOAST_ERROR,
} from "../../utils/common.service";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function AddSubAdmin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modules, setModules] = useState([]);
  const [showPassword, setShowPassword] = useState(false);

  const { register, handleSubmit, formState: { errors }, setValue, reset, getValues } = useForm();


  useEffect(() => {
    const fetchModule = async () => {
      try {
        dispatch(setLoader(true));
        const response = await API.getAllModuleApi();
        //console.log("All module Api response", response);
        setModules(response.data);
        dispatch(setLoader(false));
      } catch (error) {
        dispatch(setLoader(false));
        TOAST_ERROR("Failed to load User Details");
      }
    };

    fetchModule();
  }, [dispatch]);

  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));
      const { name, email, phone, password, permissions, getValues } =
        submitData;

      // Transform the permissions into the required format
      const transformedPermissions = modules.map((module) => ({
        module_id: module.id,
        add: permissions[module.name]?.add ? 1 : 0,
        update: permissions[module.name]?.update ? 1 : 0,
        delete: permissions[module.name]?.delete ? 1 : 0,
        view: permissions[module.name]?.view ? 1 : 0,
      }));

      // Construct the request body
      const requestBody = {
        name,
        email,
        phone,
        password,
        permissions: transformedPermissions,
      };

      const { code, message } = await API.addSubadminApi(requestBody);

      if (code === "1") {
        SWIT_SUCCESS(message);
        navigate(`/manage_subadmin`);
        reset();
      }

      dispatch(setLoader(false));
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  const handleSelectAllPermissions = (isChecked) => {
    modules.forEach((module) => {
      // Check the "All" checkbox for the module
      setValue(`permissions.${module.name}.view`, isChecked);
      setValue(`permissions.${module.name}.add`, isChecked);
      setValue(`permissions.${module.name}.update`, isChecked);
      setValue(`permissions.${module.name}.delete`, isChecked);
      document.getElementById(`select-all-${module.name}`).checked = isChecked;
    });
  };
  

  // Handle Select All Permissions for a Specific Module
  const handleSelectModulePermissions = (moduleName, isChecked) => {
    setValue(`permissions.${moduleName}.view`, isChecked); // Always check the view permission first
    setValue(`permissions.${moduleName}.add`, isChecked);
    setValue(`permissions.${moduleName}.update`, isChecked);
    setValue(`permissions.${moduleName}.delete`, isChecked);
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar
            title="Add Sub Admin"
            header="Sub Admin"
            subHeader="Add Sub Admin"
          />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                   <IoMdArrowRoundBack fontSize={"20px"}/>
                </button>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                {/* Name and Email */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="name" className="form-label">
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      className={`form-control ${
                        errors.name ? "is-invalid" : ""
                      }`}
                      placeholder="Enter name"
                      {...register("name", TEXT_WITH_SPACE_VALIDATION("name"))}
                    />
                    <div className="invalid-feedback">
                      {errors.name?.message}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="text"
                      id="email"
                      className={`form-control ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      placeholder="Enter email"
                      {...register("email", EMAIL_VALIDATION())}
                    />
                    <div className="invalid-feedback">
                      {errors.email?.message}
                    </div>
                  </div>
                </div>

                {/* Phone and Password */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="phone" className="form-label">
                      Phone No
                    </label>
                    <input
                      type="text"
                      id="phone"
                      className={`form-control ${
                        errors.phone ? "is-invalid" : ""
                      }`}
                      placeholder="Enter phone number"
                      {...register("phone", MOBILE_VALIDATION())}
                    />
                    <div className="invalid-feedback">
                      {errors.phone?.message}
                    </div>
                  </div>

                  <div className="col-md-6">
                  <label htmlFor="password" className="form-label">
                          Password
                        </label>
                        <div className="position-relative">
                          <input
                            className="form-control"
                            type={showPassword ? "text" : "password"}
                            id="password"
                            placeholder="Enter your password"
                            {...register("password", PASSWORD_VALIDATION())}
                            aria-invalid={errors.password ? "true" : "false"}
                          />
                          <span
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <Icon
                              icon={showPassword ? eye : eyeOff}
                              size={20}
                            />
                          </span>
                        </div>
                        <label className="errorc">
                          {errors.password?.message}
                        </label>
                  </div>
                </div>

                {/* Module Permissions */}
                <div className="container mt-4">
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <h5 className="mb-3">Module Permissions</h5>
                      {/* Select all permissions button */}
                      <div className="form-check mb-4">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="select-all-permissions"
                          onChange={(e) =>
                            handleSelectAllPermissions(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="select-all-permissions"
                        >
                          Give All Permissions
                        </label>
                      </div>

                      {modules.length > 0 ? (
                        modules.map((module, index) => (
                          <div key={index} className="card mb-3">
                            <div className="card-body">
                              <h4 className="card-title d-flex align-items-center">
                                {module.name}
                              </h4>

                              {/* Module Permissions */}
                              <div className="d-flex align-items-center">
                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`select-all-${module.name}`}
                                    onChange={(e) =>
                                      handleSelectModulePermissions(
                                        module.name,
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`select-all-${module.name}`}
                                  >
                                    All
                                  </label>
                                </div>
                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`view-${module.name}`}
                                    {...register(
                                      `permissions.${module.name}.view`
                                    )}
                                    onChange={(e) => {
                                      // Use getValues to fetch the current state of other permissions
                                      const addChecked = getValues(
                                        `permissions.${module.name}.add`
                                      );
                                      const updateChecked = getValues(
                                        `permissions.${module.name}.update`
                                      );
                                      const deleteChecked = getValues(
                                        `permissions.${module.name}.delete`
                                      );

                                      // Only allow unchecking view if no other permissions are checked
                                      if (
                                        !addChecked &&
                                        !updateChecked &&
                                        !deleteChecked
                                      ) {
                                        setValue(
                                          `permissions.${module.name}.view`,
                                          e.target.checked
                                        );
                                      } else {
                                        setValue(
                                          `permissions.${module.name}.view`,
                                          true
                                        ); // Prevent unchecking if other permissions are selected
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`view-${module.name}`}
                                  >
                                    View
                                  </label>
                                </div>

                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`add-${module.name}`}
                                    {...register(
                                      `permissions.${module.name}.add`
                                    )}
                                    onChange={(e) => {
                                      setValue(
                                        `permissions.${module.name}.add`,
                                        e.target.checked
                                      );
                                      if (e.target.checked) {
                                        setValue(
                                          `permissions.${module.name}.view`,
                                          true
                                        );
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`add-${module.name}`}
                                  >
                                    Add
                                  </label>
                                </div>

                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`update-${module.name}`}
                                    {...register(
                                      `permissions.${module.name}.update`
                                    )}
                                    onChange={(e) => {
                                      setValue(
                                        `permissions.${module.name}.update`,
                                        e.target.checked
                                      );
                                      if (e.target.checked) {
                                        setValue(
                                          `permissions.${module.name}.view`,
                                          true
                                        ); // Ensure view is checked
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`update-${module.name}`}
                                  >
                                    Update
                                  </label>
                                </div>

                                <div className="form-check me-3">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`delete-${module.name}`}
                                    {...register(
                                      `permissions.${module.name}.delete`
                                    )}
                                    onChange={(e) => {
                                      setValue(
                                        `permissions.${module.name}.delete`,
                                        e.target.checked
                                      );
                                      if (e.target.checked) {
                                        setValue(
                                          `permissions.${module.name}.view`,
                                          true
                                        ); // Ensure view is checked
                                      }
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`delete-${module.name}`}
                                  >
                                    Delete
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>Loading modules...</p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="mb-0 text-center">
                  <button
                    className="btn btn-primary w-25 buttonColor"
                    type="submit"
                  >
                    <i className="ri-save-fill"></i>
                    <span className="fw-bold">Add</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
